export const PROMPT_TAB_STORAGE_KEY = 'scribbler-prompt-category'

export const PromptTabValue = {
  favorites: 'favorites',
  standard: 'standard',
  custom: 'custom',
} as const

export type PromptTabValue = (typeof PromptTabValue)[keyof typeof PromptTabValue]

const PROMPT_TAB_VALUES = new Set<string>(Object.values(PromptTabValue))

export function isPromptTabValue(value: unknown): value is PromptTabValue {
  return typeof value === 'string' && PROMPT_TAB_VALUES.has(value)
}

export function getStoredPromptTab(): PromptTabValue | null {
  try {
    const stored = localStorage.getItem(PROMPT_TAB_STORAGE_KEY)

    if (stored && isPromptTabValue(stored)) {
      return stored
    }
  } catch (error) {
    console.warn('Could not read the prompt tab from localStorage:', error)
  }

  return null
}

export function savePromptTab(tab: PromptTabValue) {
  try {
    localStorage.setItem(PROMPT_TAB_STORAGE_KEY, tab)
  } catch (error) {
    console.warn('Could not save the prompt tab to localStorage:', error)
  }
}

export function getDefaultPromptTab(hasFavorites: boolean): PromptTabValue {
  return hasFavorites ? PromptTabValue.favorites : PromptTabValue.standard
}

export function clearStoredPromptTab() {
  try {
    localStorage.removeItem(PROMPT_TAB_STORAGE_KEY)
  } catch (error) {
    console.warn('Could not clear the prompt tab from localStorage:', error)
  }
}

export function resolveInitialPromptTab(hasFavorites: boolean): PromptTabValue {
  return getStoredPromptTab() ?? getDefaultPromptTab(hasFavorites)
}
